import { Mask } from './Input';

export default function maskWarning(maskProps?: Mask | string) {
  const mask = maskProps as Mask;
  // @ts-ignore
  const condition = mask && mask.decimalScale > 16 && mask.isNumericString === true;
  const message = `'Input' component mask cannot have isNumericString = true when decimalScale is bigger than 16. Please set isNumericString to false`;
  if (process.env.NODE_ENV !== 'production' && condition) {
    console.warn(message);
  }
  return null;
}
